<template>
<div class="row m-0 my-2 justify-content-start align-items-center">
	<!-- Previous day button -->
	<div class="col-auto checkbox m-0 g-0 p-0 me-2 ">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm mx-1 me-2"
			@click="readPreviousDay"
		>
			<button-icon icon="triangle-left" fill="currentColor" />
		</button>
	</div>
	<!-- Day input field -->
	<div class="col-auto checkbox m-0 g-0 p-0 me-2">
		<input
			ref="curentDayInput"
			:value="makeDateForInput(currentDay)"
			@input="setCurrentDay($event.target.value)"
			type="date"
			:max="makeDateForInput(new Date())"
			class="form-control form-control-sm"
		>
	</div>
	<!-- Next day button -->
	<div class="col-auto checkbox m-0 g-0 p-0 me-2 ">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm mx-1 ms-2"
			@click="readNextDay"
		>
			<button-icon icon="triangle-right" fill="currentColor" />
		</button>
	</div>

	<!-- Columns order -->
	<div class="col-md-auto col-12 m-0 g-0 p-0 ms-lg-5 mt-md-0 mt-3">
		<div class="form-check form-switch ms-1">
			<input
				class="form-check-input me-1"
				type="checkbox"
				role="switch"
				name="orderSwitch"
				id="orderSwitch"
				v-model="isEditOrder"
			>
			<!-- @change="customNav.linesArray.filter((line) => line.collection == collection)[0].eventHandler()" -->
			<label class="form-check-label" for="orderSwitch">
				Змінити порядок стовпців
			</label>
		</div>
	</div>

	<!-- Columns filter -->
	<div class="col-md-auto col-12 checkbox m-0 g-0 p-0 ms-lg-5 ">
		<table-filter-checkboxes
			:criterias="tableColumns"
			:default-checked="sessionStore.getFilter($route.name, 'columns')"
			button-text="Стовпці"
			@checked-criterias="(criterias) => { saveFiters('columns', criterias) }"
		/>
	</div>
</div>

<easy-data-table
	class="data-table mb-2"
	table-class-name="customize-table"
	:headers="tableHeadersFiltered"
	:items="tableItems"
	theme-color="rgb(198, 199, 200)"
	:sort-by="sortBy"
	:sort-type="sortType"
	header-text-direction="center"
	:table-min-height="380"
	:table-height="tableHeight"
	:rows-per-page="24*60"
	body-expand-row-class-name="expand-row-no-background"
	:loading="tableItems.length == 0"
	alternating
	hide-footer="true"
	@expand-row="loadHour"
>
	<!-- If rows is empty -->
	<template #empty-message>
		<span v-if="fetchResult">
			{{ fetchResult }}
		</span>
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<template #header="header">
		<!-- {{ console.log('header', header) }} -->
		<div class="row row-cols-1 text-center g-1 w-100 h-100">
			<div class="col">
				{{ header.text }}
			</div>

			<!-- Column swap buttons -->
			<div
				v-if="isEditOrder && !['expand', 'time'].includes(header.value)"
				class="col mb-0 pb-0 py-2"
			>
				<!-- <br v-if="isEditOrder && header.value !== 'expand'"> -->
				<button
					v-if="tableHeadersFiltered.findIndex((el) => el.value == header.value) > 1"
					type="button"
					class="btn btn-outline-secondary btn-sm order-btn m-0 mx-1 ms-2 p-0 px-1"
					@click="shiftColumnLeft(header.value)"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="" viewBox="0 0 16 16">
						<path fill-rule="evenodd" d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"/>
					</svg>
				</button>
				<button
					v-if="tableHeadersFiltered.findIndex((el) => el.value == header.value) < tableHeadersFiltered.length - 1"
					type="button"
					class="btn btn-sm btn-outline-secondary order-btn m-0 mx-1 p-0 px-1"
					@click="shiftColumnRight(header.value)"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="" viewBox="0 0 16 16">
						<path fill-rule="evenodd" d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"/>
					</svg>
				</button>
			</div>
		</div>
	</template>

	<template #expand="item">
		<div style="padding: 0px; padding-left: 30px; background-color: inherit;">
			<easy-data-table
				id="no-scroll-table"
				class="data-table"
				table-class-name="customize-table"
				:headers="tableHeadersFiltered"
				:items="item.expand"
				:rows-per-page="60"
				:loading="item.loading"
				theme-color="rgb(198, 199, 200)"
				:sort-by="sortBy"
				:sort-type="sortType"
				empty-message="немає записів"
				alternating
				hide-footer="true"
			>
				<template #loading>
					<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</template>

				<template #customize-headers>
				</template>

				<!-- Time item customization -->
				<template #item-time="{ time }">
					{{ dateTimeToString(time, false) }}
				</template>

				<!-- State item customization -->
				<template #item-state="{ state }">
					<span v-for="(promt, index) in state" :key="index">
						{{ promt }} <br>
					</span>
				</template>

				<!-- Connection state mapping for modem unit customization -->
				<template #item-modem_unit_is_connection="{
					modem_unit_is_connection,
					modem_unit_sig_level_1,
					modem_unit_sig_level_2
				}">
					<span :class="{
						'text-success': modem_unit_is_connection,
						'text-danger': !modem_unit_is_connection,
					}">
						{{ unitConnectionMapping(modem_unit_is_connection) }}
					</span>
					<span v-if="modem_unit_is_connection == true">
						&nbsp;{{ fixNumberPrecision(ModemUnit.makeConnectionQualityInPercent(modem_unit_sig_level_1, modem_unit_sig_level_2), 0) }}%
					</span>
				</template>

				<!-- Connection state mapping for power unit customization -->
				<template #item-power_unit_is_connection="{ power_unit_is_connection }">
					<span :class="{
						'text-success': power_unit_is_connection,
						'text-danger': !power_unit_is_connection,
					}">
						{{ unitConnectionMapping(power_unit_is_connection) }}
					</span>
				</template>

				<!-- Connection state mapping for service unit customization -->
				<template #item-service_unit_is_connection="{ service_unit_is_connection }">
					<span :class="{
						'text-success': service_unit_is_connection,
						'text-danger': !service_unit_is_connection,
					}">
						{{ unitConnectionMapping(service_unit_is_connection) }}
					</span>
				</template>
			</easy-data-table>
		</div>
	</template>

	<!-- Time item customization -->
	<template #item-time="{ time }">
		{{ dateTimeToString(time, false) }}
	</template>

	<!-- State item customization -->
	<template #item-state="{ state }">
		<span v-for="(promt, index) in state" :key="index">
			{{ promt }} <br>
		</span>
	</template>

	<!-- Connection state mapping for modem unit customization -->
	<template #item-modem_unit_is_connection="{
		modem_unit_is_connection,
		modem_unit_sig_level_1,
		modem_unit_sig_level_2
	}">
		<span :class="{
			'text-success': modem_unit_is_connection,
			'text-danger': !modem_unit_is_connection,
		}">
			{{ unitConnectionMapping(modem_unit_is_connection) }}
		</span>
		<span v-if="modem_unit_is_connection == true">
			&nbsp;{{ fixNumberPrecision(ModemUnit.makeConnectionQualityInPercent(modem_unit_sig_level_1, modem_unit_sig_level_2), 0) }}%
		</span>
	</template>

	<!-- Connection state mapping for power unit customization -->
	<template #item-power_unit_is_connection="{ power_unit_is_connection }">
		<span :class="{
			'text-success': power_unit_is_connection,
			'text-danger': !power_unit_is_connection,
		}">
			{{ unitConnectionMapping(power_unit_is_connection) }}
		</span>
	</template>

	<!-- Connection state mapping for service unit customization -->
	<template #item-service_unit_is_connection="{ service_unit_is_connection }">
		<span :class="{
			'text-success': service_unit_is_connection,
			'text-danger': !service_unit_is_connection,
		}">
			{{ unitConnectionMapping(service_unit_is_connection) }}
		</span>
	</template>
</easy-data-table>
</template>




<script>
import TableFilterCheckboxes from '@/components/TableFilterCheckboxes.vue'
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import {
	dateTimeToString,
	fixNumberPrecision,
	easyDataTableHeight,
	easyDataTableRowsPerPage,
	capitalizeFirstLetter,
} from '@/helpers.js'
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore'
import { useReportStore } from '@/stores/ReportStore'
import { useSessionStore } from '@/stores/SessionStore'
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ElectricMeter } from '@/models/electricMeter.js'
import { ModemUnit } from '@/models/modemUnit.js'


export default {
	EMPTY_STATE: ' ',
	inject: ['headerHeight'],


	components: {
		TableFilterCheckboxes,
		ButtonIcon,
	},


	props: {
		stationId: {
			type: String,
			require: true,
		},
	},


	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const reportStore = useReportStore()
		const sessionStore = useSessionStore()

		return {
			accountStore,
			stationsStore,
			reportStore,
			sessionStore,
			dateTimeToString,
			fixNumberPrecision,
			Station,
			ModemUnit,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
		}
	},


	data() {
		return {
			// Text promt
			fetchResult: null,

			// Table
			tableItems: [],
			currentDay: new Date(),
			sortBy: 'time', // for other columns need to adjust readCurrentDay() and loadHour()
			sortType: 'asc',

			isEditOrder: false,
		}
	},


	async created() {
		await this.readCurrentDay()
		
		if (this.tableItems.length == 0) {
			this.fetchResult = 'Записів журналу не знайдено або сервер не відповідає на запит'
		}

		this.initCollumnsOrder()
	},

	mounted() {},

	methods: {
		initCollumnsOrder() {
			const orders = this.sessionStore.getOrder(this.$route.name, 'table')
			const headers = this.tableHeaders
			// If columns length is not equal or there is new columns in header
			if (Object.keys(orders).length != headers.length
				|| headers.some((el) => !Object.hasOwn(orders, el.value))
			) {
				// Init headers order
				// Clean orders
				for (const prop in orders) {
					if (Object.hasOwn(orders, prop)) {
						delete orders[prop]
					}
				}
				// Set default order
				let order = 0
				for (const [, header] of headers.entries()) {
					orders[header.value] = order
					order++
				}
			}
		},

		setCurrentDay(dateString) {
			const date = new Date(dateString)

			// If date is valid and befor now
			if (date instanceof Date
				&& !isNaN(date)
				&& date.getTime() <= (new Date()).getTime()) {
				this.currentDay = date

				this.tableItems.length = 0
				this.readCurrentDay()
			}
		},

		async readCurrentDay() {
			let rows = Array()
			rows = await this.reportStore.getDay(
				this.station.passport.get(Station.passportKeys.metricsId),
				this.currentDay
			)

			rows = this._dbRowsToTableRows(rows)
			// Add empty expand section
			rows.map((row) => {
				row.expand = []
				row.loading = true
				if (this.sortType == 'asc') {
					// substract 1 hour
					row.time = new Date(row.time.getTime() - (1 * 3600 * 1000))
				}
			})

			// Clean table
			// this.tableItems.length = 0
			//
			// this.tableItems = this.tableItems.concat(rows)
			this.tableItems = rows
		},

		_dbRowsToTableRows(rows, prevValuesStore=undefined) {
			const timeNow = new Date()
			let tableRows = []

			const flagParser = (value, invert=false) => { 
				if (value == false || value == 0) {
					return invert ? 'так' : 'ні'
				} else if (value == true ||
					(value > 0 && value <= 1)
				) {
					return invert ? 'ні' : 'так'
				} else {
					return '-'
				}
			}
			
			// Iterate rows, separate by days
			rows.forEach((record) => {
				// If record is in future
				if (record.time > timeNow) {
					tableRows.push({ time: record.time })
					return
				}
				
				const copy = { ...record }
				let key

				// console.log('Row ', copy)
				key = `power_unit_${PowerUnit.metricKeys.fBreakCurrent}`
				copy[key] = flagParser(copy[key])

				key = `service_unit_${ServiceUnit.metricKeys.fSecurityCircuitBoxDoor}`
				if (copy[key] == ServiceUnit.boxDoorStateCodes.short) {
					copy[key] = ServiceUnit.boxDoorStatePromt(ServiceUnit.boxDoorStateCodes.short)
				} else if (copy[key] > ServiceUnit.boxDoorStateCodes.short && copy[key] <= ServiceUnit.boxDoorStateCodes.close) {
					copy[key] = ServiceUnit.boxDoorStatePromt(ServiceUnit.boxDoorStateCodes.close)
				} else if (copy[key] > ServiceUnit.boxDoorStateCodes.close && copy[key] <= ServiceUnit.boxDoorStateCodes.open) {
					copy[key] = ServiceUnit.boxDoorStatePromt(ServiceUnit.boxDoorStateCodes.open)
				} else {
					copy[key] = '-'
				}

				key = `service_unit_${ServiceUnit.metricKeys.fExternalPwr}`
				copy[key] = flagParser(copy[key], true)

				key = `power_unit_${PowerUnit.metricKeys.fBreakPotential}`
				copy[key] = flagParser(copy[key])

				copy['outPower'] = copy['power_unit_Iout'] !== null && copy['power_unit_Iout'] !== undefined && copy['power_unit_Uout'] !== null && copy['power_unit_Uout'] !== undefined
					? copy['power_unit_Iout'] * copy['power_unit_Uout']
					: '-'
				
				copy['resistancePolarizationCircle'] =
					Number.isFinite(copy['power_unit_Uout'] / copy['power_unit_Iout'])
					? copy['power_unit_Uout'] / copy['power_unit_Iout']
					: '-'
				// console.log(Number.isFinite(copy['power_unit_Uout'] / copy['power_unit_Iout']), copy['resistancePolarizationCircle'])

				key = 'electricMeterValue'
				switch(this.station.passport?.get(Station.passportKeys.electricMeter.self)?.type) {
					// Meter type is impulse imput of service unit
					case ElectricMeter.versions.impulseInput: {
						let value = copy[`service_unit_${ServiceUnit.metricKeys.extPwrCounterEnergy}`]
						if (value === undefined || value === '') {
							copy[key] = null
						} else {
							copy[key] = value
						}
						break
					}
					// Meter type is nik dlms or gama100
					case ElectricMeter.versions.nikDlms:
					case ElectricMeter.versions.gama100G1m:
					case ElectricMeter.versions.gama100G1b:
						copy[key] =
							copy[`electric_meter_unit_${ElectricMeter.metricKeys.fullActiveEnergy}`] === undefined
							? null
							: copy[`electric_meter_unit_${ElectricMeter.metricKeys.fullActiveEnergy}`]
						break
					default:
						copy[key] = null
				}

				if (copy[`power_unit_${PowerUnit.metricKeys.stabilizationModeSetting}`]
					&& copy[`power_unit_${PowerUnit.metricKeys.stabilizationValueSetting}`]
				){
					copy['stabilizationSetting'] = `${copy[`power_unit_${PowerUnit.metricKeys.stabilizationModeSetting}`]} = ${copy[`power_unit_${PowerUnit.metricKeys.stabilizationValueSetting}`]}`
				} else {
					copy['stabilizationSetting'] = '-'
				}

				// Normalize numbers
				Object.keys(copy).forEach((key) => {
					copy[key] = fixNumberPrecision(copy[key])
				})

				this.alertPromts(copy)

				// Verbalization station mode
				key = `power_unit_${PowerUnit.metricKeys.stationStabilizationMode}`
				copy[key] = PowerUnit.stabilizationModeText(
					copy[key],
					{
						[PowerUnit.metricKeys.stationStabilizationPotential]: copy[`power_unit_${PowerUnit.metricKeys.stationStabilizationPotential}`],
						[PowerUnit.metricKeys.stationStabilizationVoltage]: copy[`power_unit_${PowerUnit.metricKeys.stationStabilizationVoltage}`],
						[PowerUnit.metricKeys.stationStabilizationCurent]: copy[`power_unit_${PowerUnit.metricKeys.stationStabilizationCurent}`],

					},
					this.station?.passport.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.unitVersion]
				)

				// Fill to row previuos values if value is empty
				if (prevValuesStore === undefined) {
					// Init store
					prevValuesStore = copy
				}
				for (const [key, value] of Object.entries(copy)) {
					if (key == 'time') {
						continue
					}

					// If curent row value is empty and prev row value is not empty
					if ((value == '-' || value == '')
						&& prevValuesStore != '-'
						&& prevValuesStore != ''
					) {
						copy[key] = prevValuesStore[key]
					} else {
						prevValuesStore[key] = copy[key]
					}
				}
				
				tableRows.push(copy)
			})

			// Reverse array
			tableRows.reverse()

			return tableRows
		},

		readPreviousDay() {
			this.currentDay = this.reportStore.prevDay(this.currentDay)
			this.tableItems.length = 0
			this.readCurrentDay()
		},

		readNextDay() {
			const nextDay = this.reportStore.nextDay(this.currentDay)
			// If next day is after today
			if ((new Date()).getTime() < nextDay.getTime()) {
				return
			}

			this.currentDay = nextDay
			this.tableItems.length = 0
			this.readCurrentDay()
		},

		unitConnectionMapping(state) {
			if (state === null || state === undefined) {
				return "-"
			} else if (state === true) {
				return 'Є'
			} else if (state === false) {
				return 'НЕМАЄ'
			} else {
				return state
			}
		},

		alertPromts(state) {
			let promts = new Array()

			state.state = "-"

			PowerUnit.alertKeys.forEach(key => {
				if (state["power_unit_"+key] === true) {
					promts.push(capitalizeFirstLetter(PowerUnit.alertPromt(key) ?? '-'))
					state.state += capitalizeFirstLetter(PowerUnit.alertPromt(key) ?? '-')
				}
			})

			// Service unit alerts
			this.station.service_unit.activeSecurityCircuits.forEach(circuit => {
				const key = 'f_security_circuit_' + circuit
				const stateCode = state["service_unit_"+key]
				
				if (stateCode) {
					promts.push(capitalizeFirstLetter(ServiceUnit.alertPromt(key,  parseInt(stateCode)) ?? '-'))
					state.state += capitalizeFirstLetter(ServiceUnit.alertPromt(key,  parseInt(stateCode)) ?? '-')
				}
			})

			if (promts.length === 0) {
				promts.push(this.$options.EMPTY_STATE)
			}

			return promts
		},

		async loadHour(index) {
			const tableItemsIndex = this.sortType == 'desc' ? index : (23 - index)
			const hourItem = this.tableItems[tableItemsIndex]
			hourItem.loading = true
			const hourStartDate = new Date(
				new Date(this.currentDay.getTime())
					.setHours(this.sortType == 'asc' ? index : (23 - index), 0, 0, 0)
			)

			let rows = await this.reportStore.getHour(
				this.station.passport.get(Station.passportKeys.metricsId),
				hourStartDate
			)

			rows.pop() // delete first element (same as in hour table)

			// Try to get previuos row from hour row
			let prevRow = undefined
			const tableItemsPrevRowIndex = this.sortType == 'desc' ? (tableItemsIndex + 1) : (tableItemsIndex - 1)
			if (this.tableItems[tableItemsPrevRowIndex]) {
				prevRow = { ...this.tableItems[tableItemsPrevRowIndex] }
				// console.log('prev row', prevRow)
			}

			rows = this._dbRowsToTableRows(rows, prevRow)
			// rows = this._dbRowsToTableRows(rows)

			// Clean empty rows
			for (const row of rows) {
				for (const property in row) {
					const cell = row[property]
					if ([
						'time',
						'state',
						'power_unit_stabilization_current_actual_value',
						'power_unit_stabilization_potential_actual_value',
						'power_unit_stabilization_voltage_actual_value'
						].includes(property)
					) {
						continue
					}

					if (cell != '-'
						&& cell !== null
						&& cell !== undefined
						&& cell !== ''
					) {
						hourItem.expand.push(row)
						break
					}
				}
			}

			// if (hourItem.expand.length == 0) {
			// 	hourItem.expand.push(rows[0])
			// }

			hourItem.loading = false
		},

		makeDateForInput(date) {
			return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
		},

		saveFiters(filterName, criterias) {
			const filters = this.sessionStore.getFilter(this.$route.name, filterName)
			filters.splice(0, filters.length)
			filters.push(...criterias)
		},

		shiftColumnLeft(colId) {
			const orders = this.sessionStore.getOrder(this.$route.name, 'table')
			const indexInFiltered = this.tableHeadersFiltered.findIndex((el) => el.value == colId)
			
			// If left column
			if (indexInFiltered == 1) {
				return
			}
			const prevColId = this.tableHeadersFiltered[indexInFiltered - 1].value;

			[orders[colId], orders[prevColId]] = [orders[prevColId], orders[colId]]
		},

		shiftColumnRight(colId) {
			const orders = this.sessionStore.getOrder(this.$route.name, 'table')
			const indexInFiltered = this.tableHeadersFiltered.findIndex((el) => el.value == colId)

			// If right column
			if (indexInFiltered == this.tableHeadersFiltered.length - 1) {
				return
			}

			const nextColId = this.tableHeadersFiltered[indexInFiltered + 1].value;

			[orders[colId], orders[nextColId]] = [orders[nextColId], orders[colId]]
		},
	},


	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		tableHeight() { return easyDataTableHeight() - 20 },

		tableHeaders() {
			return [
				{ text: "Часовий період", value: "time", width: 160, fixed: true, },
				{ text: "Режим стабілізації", value: "power_unit_" + PowerUnit.metricKeys.stationStabilizationMode, width: 130, },
				{ text: "Стан", value: "state", sortable: !this.isEditOrder, width: 250, },
				{ text: "Вихідний струм, A", value: "power_unit_Iout", },
				{ text: "Вихідна напруга, В ", value: "power_unit_Uout" },
				{ text: "Захисний потенціал, В", value: "power_unit_Uprotect_sum" },
				{ text: "Emin, В", value: "service_unit_Uprotect_min" },
				{ text: "Emax, В", value: "service_unit_Uprotect_max" },
				{ text: "Eavg, В", value: "service_unit_Uprotect_avg" },
				{ text: "Обрив кабелю анодного заземлювача", value: 'power_unit_' + PowerUnit.metricKeys.fBreakCurrent },
				{ text: "Відкриття корпусу СКЗ", value: `service_unit_${ServiceUnit.metricKeys.fSecurityCircuitBoxDoor}` },
				{ text: "Обрив мережі живлення", value: `service_unit_${ServiceUnit.metricKeys.fExternalPwr}` },
				{ text: "Обрив МСЕП", value: `power_unit_${PowerUnit.metricKeys.fBreakPotential}` },
				{ text: "Напруга мережі, В", value: "service_unit_U220" },
				{ text: "Вихідна потужність, Вт", value: "outPower" },
				{ text: "Опір кола поляризації, Ом", value: "resistancePolarizationCircle" },
				{ text: "Спожито, кВт⋅год", value: "electricMeterValue" },
				{ text: "Температура в шафі СКЗ, °C", value: `service_unit_${ServiceUnit.metricKeys.tOutdoor}` },
				{ text: "Напруга АКБ, В", value: `service_unit_${ServiceUnit.metricKeys.uAkk}` },
				{ text: "Задане значення", value: "stabilizationSetting" },
				{ text: "Eвимк., В", value: "service_unit_off_station_potential_avg", sortable: !this.isEditOrder, },
				{ text: "Зв'язок модем", value: "modem_unit_is_connection" },
				{ text: "Зв'язок сил.м.", value: "power_unit_is_connection" },
				{ text: "Зв'язок серв.м.", value: "service_unit_is_connection" },
			]
		},

		tableHeadersOrdered() {
			const orders = this.sessionStore.getOrder(this.$route.name, 'table')
			const headers = this.tableHeaders

			for (const [, header] of headers.entries()) {
				header.order = orders[header.value]
			}

			headers.sort((a, b) => a.order - b.order)

			return headers
		},

		tableColumns() {
			return this.tableHeadersOrdered.map((col) => col.text)
		},

		tableHeadersFiltered() {
			//console.log('filter', this.sessionStore.getFilter(this.$route.name, 'columns'))
			const columns = this.sessionStore.getFilter(this.$route.name, 'columns')
			return this.tableHeadersOrdered.filter((el) => columns.includes(el.text))
		},
	},
}
</script>




<style src="@/assets/table.css" scoped />
<style scoped>
.order-btn:hover svg path{
	fill: #0a58ca
}

.item-name-link {
	display: block;
	width: 100%;
	height: 100%;
}
</style>

<style>
/* .header-item span {
	width: 100% !important;
	height: 100% !important;
	display: flexbox !important;
} */

#no-scroll-table .vue3-easy-data-table__main {
	/* overflow: hidden !important; */
	overflow: visible !important;
	max-height: 100% !important;
	display: block;
}

/* Manual background set */
#no-scroll-table tr {
	background-color: #fff;
}
#no-scroll-table .even-row {
	/* background-color: inherit !important; */
	background-color: #eee !important;
}
</style>